import actions from "./actions";

const {
  FETCH_DEVICE_DETAILS_BEGIN,
  FETCH_DEVICE_DETAILS,
  FETCH_DEVICE_DETAILS_ERR,

  FETCH_ALL_QUESTIONS_LIST_BEGIN,
  FETCH_ALL_QUESTIONS_LIST,
  FETCH_ALL_QUESTIONS_LIST_ERR,

  CREATE_SURVEY_BEGIN,
  CREATE_SURVEY,
  CREATE_SURVEY_ERR,

  FETCH_ALL_SURVEY_LIST_BEGIN,
  FETCH_ALL_SURVEY_LIST,
  FETCH_ALL_SURVEY_LIST_ERR,

  FETCH_SURVEY_DETAILS_BEGIN,
  FETCH_SURVEY_DETAILS,
  FETCH_SURVEY_DETAILS_ERR,

  UPDATE_SURVEY_DETAILS_BEGIN,
  UPDATE_SURVEY_DETAILS,
  UPDATE_SURVEY_DETAILS_ERR,

  FETCH_EXP_REPORT_DETAILS_BEGIN,
  FETCH_EXP_REPORT_DETAILS,
  FETCH_EXP_REPORT_DETAILS_ERR,

  FETCH_EXP_BRANCH_REPO_DETAILS_BEGIN,
  FETCH_EXP_BRANCH_REPO_DETAILS,
  FETCH_EXP_BRANCH_REPO_DETAILS_ERR,

  FETCH_BRANCH_REPO_DETAILS_BEGIN,
  FETCH_BRANCH_REPO_DETAILS,
  FETCH_BRANCH_REPO_DETAILS_ERR,

  FETCH_QNANS_REPORT_BEGIN,
  FETCH_QNANS_REPORT,
  FETCH_QNANS_REPORT_ERR,

  FETCH_CASE_BR_REPORT_BEGIN,
  FETCH_CASE_BR_REPORT,
  FETCH_CASE_BR_REPORT_ERR,

  FETCH_CASER_OVER_REPORT_BEGIN,
  FETCH_CASER_OVER_REPORT,
  FETCH_CASER_OVER_REPORT_ERR,

  FETCH_CASER_OVER_PERIOD_BEGIN,
  FETCH_CASER_OVER_PERIOD,
  FETCH_CASER_OVER_PERIOD_ERR,

  FETCH_EXCEL_REPORT_BEGIN,
  FETCH_EXCEL_REPORT,
  FETCH_EXCEL_REPORT_ERR,

  UPDATE_PASSWORD_DETAILS_BEGIN,
  UPDATE_PASSWORD_DETAILS,
  UPDATE_PASSWORD_DETAILS_ERR,
} = actions;

const initialStateFilter = {
  data: [],
  loading: false,
  error: null,
};

const DeviceDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_DEVICE_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_DEVICE_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_DEVICE_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const QuestionListReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_ALL_QUESTIONS_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_ALL_QUESTIONS_LIST:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_ALL_QUESTIONS_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const SurveyReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CREATE_SURVEY_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case CREATE_SURVEY:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case CREATE_SURVEY_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const SurveyListReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_ALL_SURVEY_LIST_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_ALL_SURVEY_LIST:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_ALL_SURVEY_LIST_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const SurveyDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_SURVEY_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_SURVEY_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_SURVEY_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const UpdateSurveyDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPDATE_SURVEY_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case UPDATE_SURVEY_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case UPDATE_SURVEY_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const expReportDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_EXP_REPORT_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_EXP_REPORT_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_EXP_REPORT_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
const expBranchRepoDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_EXP_BRANCH_REPO_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_EXP_BRANCH_REPO_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_EXP_BRANCH_REPO_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const expBranchDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_BRANCH_REPO_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_BRANCH_REPO_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_BRANCH_REPO_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const QuestionReportReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_QNANS_REPORT_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_QNANS_REPORT:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_QNANS_REPORT_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const CaseReportReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_CASE_BR_REPORT_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_CASE_BR_REPORT:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_CASE_BR_REPORT_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const CaseOverTimeReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_CASER_OVER_REPORT_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_CASER_OVER_REPORT:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_CASER_OVER_REPORT_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const CaseOverPeriodReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_CASER_OVER_PERIOD_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_CASER_OVER_PERIOD:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_CASER_OVER_PERIOD_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
const SurveyExcelReportReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case FETCH_EXCEL_REPORT_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case FETCH_EXCEL_REPORT:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case FETCH_EXCEL_REPORT_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const UpdatePasswordDetailsReducer = (state = initialStateFilter, action) => {
  const { type, data, err } = action;
  switch (type) {
    case UPDATE_PASSWORD_DETAILS_BEGIN:
      return {
        ...initialStateFilter,
        loading: true,
      };
    case UPDATE_PASSWORD_DETAILS:
      return {
        ...initialStateFilter,
        data,
        loading: false,
      };
    case UPDATE_PASSWORD_DETAILS_ERR:
      return {
        ...initialStateFilter,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export {
  QuestionListReducer,
  DeviceDetailsReducer,
  SurveyReducer,
  SurveyListReducer,
  SurveyDetailsReducer,
  UpdateSurveyDetailsReducer,
  expReportDetailsReducer,
  expBranchRepoDetailsReducer,
  expBranchDetailsReducer,
  QuestionReportReducer,
  CaseReportReducer,
  CaseOverTimeReducer,
  CaseOverPeriodReducer,
  SurveyExcelReportReducer,
  UpdatePasswordDetailsReducer,
};
